(function () {
  function lockDrawerMode() {
    var headerComponent = document.querySelector('#header-component');
    if (!headerComponent) return;

    if (headerComponent.dataset.menuStyle !== 'drawer') {
      headerComponent.dataset.menuStyle = 'drawer';
    }

    var observer = new MutationObserver(function () {
      if (headerComponent.dataset.menuStyle !== 'drawer') {
        headerComponent.dataset.menuStyle = 'drawer';
      }
    });

    observer.observe(headerComponent, { attributes: true, attributeFilter: ['data-menu-style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockDrawerMode);
  } else {
    lockDrawerMode();
  }
})();
